import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center py-20 px-4 overflow-hidden bg-dark-900" data-id="element-80">
      {/* Background ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-amber-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-81" />

      <div className="max-w-6xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center relative z-10" data-id="element-82">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-83">
          <div className="inline-block px-3 py-1 mb-6 border border-amber-gold/30 rounded-full bg-amber-gold/5 backdrop-blur-sm" data-id="element-84">
            <span className="text-amber-gold text-sm font-medium tracking-wide uppercase" data-id="element-85">
              Sistema 3 Puertas
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black tracking-tight leading-[1.1] mb-6 text-white" data-id="element-86">
            Si te da miedo empezar, <br className="hidden md:block" data-id="element-87" />
            <span className="text-amber-gold text-glow-amber" data-id="element-88">
              este PDF es para hoy.
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-text-muted font-light mb-8 leading-relaxed" data-id="element-89">
            Sistema 3 Puertas para empezar{' '}
            <span className="text-white font-medium" data-id="element-90">
              (aunque te sientas solo y perdido)
            </span>
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start mb-8" data-id="element-91">
            <motion.a href="#descargar" whileHover={{
            scale: 1.05,
            boxShadow: '0 0 35px rgba(245, 166, 35, 0.5)'
          }} whileTap={{
            scale: 0.97
          }} animate={{
            boxShadow: ['0 0 15px rgba(245, 166, 35, 0.2)', '0 0 25px rgba(245, 166, 35, 0.4)', '0 0 15px rgba(245, 166, 35, 0.2)']
          }} transition={{
            boxShadow: {
              duration: 2.5,
              repeat: Infinity,
              ease: 'easeInOut'
            }
          }} className="px-10 py-5 bg-amber-500 hover:bg-amber-400 text-dark-900 font-black text-lg rounded-xl transition-colors shadow-glow-amber flex items-center gap-3 cursor-pointer no-underline" data-id="element-92">
              Quiero empezar hoy
              <ArrowRight className="w-5 h-5" data-id="element-93" />
            </motion.a>
          </div>

          <p className="text-sm text-amber-gold/80 italic border-l-2 border-amber-gold/30 pl-4 max-w-md mx-auto lg:mx-0" data-id="element-94">
            "Un protocolo para el momento del bloqueo, no para cuando ya te
            sientes bien."
          </p>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="order-1 lg:order-2 flex justify-center" data-id="element-95">
          <div className="relative w-full max-w-[500px] aspect-[4/5] md:aspect-square lg:aspect-[4/5]" data-id="element-96">
            {/* Glow behind image */}
            <div className="absolute inset-0 bg-amber-gold/10 blur-[60px] rounded-full transform scale-90" data-id="element-97" />

            <motion.img src="https://cdn.magicpatterns.com/uploads/spFWCEgvDujivCg7A1fzWn/private_openrouter-generated-image-1770339844912.png" alt="El Miedo Diario Product Mockup" className="relative w-full h-full object-contain drop-shadow-2xl animate-float" data-id="element-98" />
          </div>
        </motion.div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-dark-900 to-transparent pointer-events-none" data-id="element-99" />
    </section>;
}